import ModalManager from "../../js/components/modalManager";

export default class InfoSummaryExtended extends HTMLElement {

    constructor() {
        super();
        this.hotelInfo = JSON.parse(this.getAttribute('hotelInfo'));
        this.hotel = this.hotelInfo.hotel;
        this.journeyData = this.hotelInfo.journeyData;
        this.schedule = this.hotelInfo.schedule;
        this.mealPlan = this.hotelInfo.mealPlan;
        this.rooms = this.hotelInfo.rooms;
        this.texts = this.hotelInfo.texts;
        this.label = this.hotelInfo.label;
        this.sideImage = JSON.parse(this.getAttribute('sideImage'));
        this.modalManager = new ModalManager();

        this.modalID = this.getAttribute('modalID');
        this.stylesheet = this.getAttribute('stylesheet');
        this.assetsCdn = this.getAttribute('assetsCdn');
    }

    static get observedAttributes() {
        return ['defaultImage', 'stylesheet', 'modalID'];
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#info-summary-extended');
        this.instance = t.content.cloneNode(true);
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        this.instance.querySelector('[name="stylesheet"]').addEventListener('load', () => {
            this.style.display = '';
        });

        if (this.hotel.address) {
            this.instance.querySelector('[name="copy-image"]').addEventListener('click', () => {
                navigator.clipboard.writeText(this.hotel.address);
            });
        } else {
            this.instance.querySelector('[name="map-container"]').style.display = "none";
        }

        const hotelInfoSummary = this.instance.querySelector('[name="hotel-info-summary"]');

        if (this.sideImage) {
            hotelInfoSummary.classList.add('side-image');
        }

        if (Object.entries(this.hotel).length > 0) {
            hotelInfoSummary.querySelector('[name="map-text"]').innerHTML = this.texts.howToGet;
            hotelInfoSummary.querySelector('[name="map-image"]').src = this.assetsCdn + '/img/web/map/map-square-sm.jpg';
            hotelInfoSummary.querySelector('[name="hotel-name"]').innerHTML = this.hotel.name;
            hotelInfoSummary.querySelector('[name="hotel-link"]').href = this.hotel.url;
            hotelInfoSummary.querySelector('[name="hotel-image"]').src = this.hotel.img;
            hotelInfoSummary.querySelector('[name="hotel-address"]').innerHTML = this.hotel.address;
            this.hotel.phone ? hotelInfoSummary.querySelector('[name="hotel-phone"]').innerHTML =
                this.hotel.phone : hotelInfoSummary.querySelector('[data-container="phone-container"]').style.display = "none";

            if (this.schedule.showScheduleInfo) {
                if (this.schedule.showCheckDate) {
                    hotelInfoSummary.querySelector('[name="checkin-date"]').innerHTML = this.schedule.checkInDate;
                    hotelInfoSummary.querySelector('[name="checkout-date"]').innerHTML = this.schedule.checkOutDate;
                }
                hotelInfoSummary.querySelector('[name="checkin-title"]').innerHTML = this.schedule.checkInText;
                hotelInfoSummary.querySelector('[name="checkin-image"]').src = this.assetsCdn + '/img/web/icon/info/clock-up.svg';
                hotelInfoSummary.querySelector('[name="checkin-time"]').innerHTML = this.schedule ? this.schedule.checkInTime : "";
                hotelInfoSummary.querySelector('[name="checkout-title"]').innerHTML = this.schedule.checkOutText;
                hotelInfoSummary.querySelector('[name="checkout-image"]').src = this.assetsCdn + '/img/web/icon/info/clock-down.svg';
                hotelInfoSummary.querySelector('[name="checkout-time"]').innerHTML = this.schedule ? this.schedule.checkOutTime : "";
            }

            if (this.hotel.id) {
                hotelInfoSummary.querySelectorAll('[name="hotel-image"], [name="hotel-show-images"]').forEach((item) => {
                    item.addEventListener('click', () => {
                        this._onClickSlider(0);
                    });
                });
            }

            let howToArriveDiv = hotelInfoSummary.querySelector('[name="map"]');

            if (this.hotel.googleMapUrlCoordinates || this.hotel.googleMapUrlAddress) {
                howToArriveDiv.addEventListener("click", (event) => {
                    this._onClickOpenUrl(this.hotel.googleMapUrlCoordinates != null ? this.hotel.googleMapUrlCoordinates : this.hotel.googleMapUrlAddress);
                });
            } else {
                howToArriveDiv.remove();
            }

            this.images = this.hotel.images;
            hotelInfoSummary.querySelector('[name="hotel-show-images"]').innerHTML = this.hotel.showImagesText;

            if (this.hotel.stars > 0) {
                this._fillCategory('star', this.hotel.stars);
            } else if (this.hotel.keys > 0) {
                this._fillCategory('key', this.hotel.keys);
            }
        } else {
            let journeyImg = this.instance.querySelector('[name="hotel-image"]');
            journeyImg.setAttribute('src', this.journeyData.img);
            hotelInfoSummary.querySelector('[name="hotel-show-images"]').classList.add('hidden');
        }

        if (this.journeyData && Object.entries(this.journeyData).length > 0) {
            this._createJourneyData(Object.entries(this.hotel).length > 0);
            this._showPreferentialEntryBadge();
        }

        if (this.mealPlan) {
            this.instance.querySelector('[name="meal-plan-section"]').classList.remove('hidden');
            this.instance.querySelector('[name="meal-plan-title"]').innerHTML = this.texts.mealPlan;
            this.instance.querySelector('[name="meal-plan-text"]').innerHTML = this.mealPlan.text;
        }

        if (this.rooms.length > 0) {
            this.instance.querySelector('[name="room-section"]').classList.remove('hidden');
            this.instance.querySelector('[name="room-title"]').innerHTML = this.texts.rooms;
            const details = this.instance.querySelector('[name="details"]');
            details.innerHTML = this.texts.details;

            this._createRoomsList(this.instance);
            if (document.querySelector('#hotel-room[data-entity="custom-modal"]')) {
                details.classList.add('room-info');
                details.onclick = (e) => {
                    myApp.customModalManager.openModal('#hotel-room');
                }
            } else {
                details.classList.remove('room-info');
            }
        }

        if (this.label) {
            let hotelImageLabel = this.instance.querySelector('[name="hotel-image-label"]');
            hotelImageLabel.innerHTML = this.label;
            hotelImageLabel.style.display = "";
        }
        this._shadowRoot.appendChild(this.instance);
    }

    _fillCategory(name, number) {
        let hotelCategoryContainer = this.instance.querySelector('[name="hotelCategory"]');

        let newNode = document.createElement('i');
        newNode.setAttribute('name', name);
        newNode.classList.add("ci", "ci-" + name, "ci-s-17");

        for (let i = 0; i < number; i++) {
            let clonedCategory = newNode.cloneNode(true);
            hotelCategoryContainer.appendChild(clonedCategory)
        }
    }

    _createRoomsList() {
        let list = this.instance.querySelector('.room-list');
        let roomList = list.querySelector('.room-items');
        let item = document.querySelector('#room');

        for (let room of this.rooms) {
            let roomElement = item.content.cloneNode(true);
            roomElement.querySelector('[name="room-seater-apartment"]').innerHTML = room.seaterApartment;
            roomElement.querySelector('[name="room-separator"]').innerHTML = " | ";
            roomElement.querySelector('[name="room-number-of-people"]').innerHTML = room.numOfPeople;
            roomElement.querySelector('[name="room-number-of-adults-and-kids"]').innerHTML = room.numOfAdultsAndKids;
            roomList.appendChild(roomElement);
        }
    }

    _createJourneyData(showHotelInfo) {
        const item = document.querySelector('#journey-data');

        let journeyData = item.content.cloneNode(true);
        journeyData.querySelector('[name="journey-data-title"]').innerHTML = this.journeyData.title;
        journeyData.querySelector('[name="journey-data-description"]').innerHTML = this.journeyData.description;
        const infoSummaryAdditionalLink = journeyData.querySelector('[name="journey-data-link"]');
        infoSummaryAdditionalLink.innerHTML = this.journeyData.moreInformation.text;
        infoSummaryAdditionalLink.href = this.journeyData.moreInformation.link;

        const hotelInfo = this.instance.querySelector('[name="hotel-info"]');
        const hotelInfoContainer = this.instance.querySelector('[name="hotel-info-summary"]');

        if (showHotelInfo) {
            hotelInfoContainer.parentNode.insertBefore(journeyData, hotelInfoContainer.nextSibling);
        } else {
            hotelInfo.innerHTML = "";
            hotelInfo.appendChild(journeyData);
            hotelInfo.appendChild(this.instance.querySelector('[name="room-section"]'));
        }
    }

    _onClickOpenUrl(url) {
        window.open(url, '_blank').focus();
    }

    _onClickSlider(sliderId) {
        this.modalManager.openModal(this.hotel.id);

        let imageGalleryItemClickListener = document.querySelector("image-gallery-list");
        if (imageGalleryItemClickListener) {
            imageGalleryItemClickListener.onShow(sliderId);
        }
    }

    _showPreferentialEntryBadge() {
        const preferentialEntryData = this.journeyData.preferentialEntry;
        const preferentialEntryBadge = this.instance.querySelector('[name="preferentialEntry-info-badge"]');
        if (!preferentialEntryBadge) {
            return;
        }

        if (preferentialEntryData?.text) {
            preferentialEntryBadge.textContent = preferentialEntryData.text;
            preferentialEntryBadge.style.display = '';
        } else {
            preferentialEntryBadge.style.display = 'none';
        }
    }
}
